import { render, staticRenderFns } from "./DocumentsAndItems.html?vue&type=template&id=e7fea3ba&scoped=true&external"
import script from "./DocumentsAndItems.js?vue&type=script&lang=js&external"
export * from "./DocumentsAndItems.js?vue&type=script&lang=js&external"
import style0 from "./DocumentsAndItems.scss?vue&type=style&index=0&id=e7fea3ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fea3ba",
  null
  
)

export default component.exports